import { RightOutlined, SearchOutlined , EditOutlined , PrinterOutlined, FileExcelOutlined} from "@ant-design/icons";
import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Input, PageHeader, Row, Select, Space, Spin, Table } from 'antd'
import { Link, useNavigate } from 'react-router-dom';

import JcpMonthlyPaidListView from '../../components/enrollment/jcp/JcpMonthlyPaidListView'
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'

import { SUCCESS_STATUS } from '../../utility/Constants'
import memberService from "../../api/member.service";
import JcpMonthlyReminderListView from "../../components/enrollment/jcp/JcpMonthlyReminderListView";
import TapMembershipListView from "../../components/tapcomponent/TapMembershipListView";
import CustomTableSearch from "../../components/common/CustomTableSearch";
import gymService from "../../api/gym.service";
import GymMembershipListView from "../../components/gymcomponent/GymMembershipListView";
import clubService from "../../api/clubaffiliation.service";
import commonUtility from "../../utility/Utils";
import { CLUB_AFFILIATION_XLS_URL, PRINT_BASE_URL } from "../../utility/URL";
const { Option } = Select;



const currdate = new Date();
//const currMonth = currdate.toLocaleString('default', { month: 'short' });
const currMonth = currdate.getMonth() + 1;
const currYear = currdate.getFullYear();


//console.log("currMonth", currYear);

const defaultFormValues = {
    month_id: currMonth,
    year: currYear,
    member_id: "",
    programme_id: 0,
    paid_unpaid_status: "ALL"
};






const ClubReceiptList = () => {
    const [form] = Form.useForm();
    const [isDataUpdated, setIsDataUpdated] = useState(false);
    const [clubReceiptList, setClubReceiptList] = useState([]);
    const [filteredSearchList, setFilteredSearchList] = useState([]);

    const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
    const [page, setPage] = React.useState(1);
    

    useEffect(()=> {
        setClubReceiptList([]);
        setFilteredSearchList([]);
        clubService.clubReceiptList().then((res) => {
//            console.log('res.data.response_data',res.data.response_data);
            setClubReceiptList(res.data.response_data);
            setFilteredSearchList(res.data.response_data)
        });  
    },[]);

    const onSearch = (e) => {
        setFilteredSearchList([]);
        const string = e.target.value;
        const x = clubReceiptList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
        setFilteredSearchList(x)
    }

    const pageSize = 10; // Number of items per page

    // Example of pagination from Ant Design Table or similar
    const pagination = {
      current: page, // Current page number
      pageSize: pageSize, // Number of items per page
    };

    const columns = [
        { 
            title: '#', 
            dataIndex: 'index', 
            render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
            width: '5%',
          },
        {
          title: 'Receipt No',
          dataIndex: 'receipt_no',
          key: 'receipt_no',
          sorter: (a, b) => a.receipt_no.localeCompare(b.receipt_no),
        },
        {
          title: 'Receipt Date',
          dataIndex: 'receipt_date',
          key: 'receipt_date',
          sorter: (a, b) => a.receipt_date.localeCompare(b.receipt_date),
        },
        {
          title: 'Club',
          dataIndex: 'club_name',
          key: 'club_name',
          sorter: (a, b) => a.club_name.localeCompare(b.club_name),
        },
       
        {
            title: 'Rate Per Year',
            dataIndex: 'rate_per_year',
            key: 'rate_per_year',
        },
        {
            title: 'Year Desc',
            dataIndex: 'ac_years_data',
            key: 'ac_years_data',
        },
        {
            title: 'No of Years',
            dataIndex: 'no_of_years',
            key: 'no_of_years',
            align:'right'
        },
        {
            title: 'GST',
            dataIndex: 'total_cgst_amount',
            key: 'total_cgst_amount',
            align:'right',
            render: (selectedObj,row) => (
                <Space size="middle">
                    {(row.total_cgst_amount+row.total_sgst_amount).toFixed(2)}
                </Space>
            )
        },
        {
            title: 'Total Paid',
            dataIndex: 'net_payble_amount',
            key: 'net_payble_amount',
            align:'right',
            render: (selectedObj,row) => (
                <Space size="middle">
                  {row.net_payble_amount.toFixed(2)}
                </Space>
            )
        },
        {
            title: 'Action',
            key: 'action',
            width:90,
            render: (selectedObj) => (
                <Space style={{display:'flex',flexDirection:'column'}}>
                    {
                        selectedObj.receipt_id == selectedObj.max_receipt_id ? <>
                        <Link to={`/clubaffiliation/entry/${selectedObj.receipt_id}/${selectedObj.payment_id}`} >
                            <Button htmlType="button" type="ghost" size="small" shape="round" className="custombutton-type1" >Edit <EditOutlined /></Button>
                        </Link>
                        </>:<></>
                    }
                    
                    <a href={`${PRINT_BASE_URL}taxinvoice/club_affiliation_print/${selectedObj.receipt_id}/${selectedObj.payment_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0 }`} target="_blank" rel="noopener noreferrer">
                        <Button htmlType="button" type="ghost" size="small" shape="round" type="primary" ><PrinterOutlined /> Print</Button>
                    </a>
                </Space>
            )
        },
        
      ];


    return (

        <div>

            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="Club Receipt List"
                        subTitle=""
                        extra={[                
                            <Button key="1" className="custom-button-white" shape="round" size="medium" onClick={() => commonUtility.openInNewTab(CLUB_AFFILIATION_XLS_URL)}>
                              <FileExcelOutlined /> Excel
                            </Button>,
                          ]}
                    ></PageHeader>

                    <CustomTableSearch onSearchTable={onSearch} style={{marginBottom: "8px"}} />
                    <div className='tableView'>
                        <div className="form-content">
                            {/* <GymMembershipListView tapMembershipList={filteredSearchList} /> */}
                            <Table 
                            rowKey={commonUtility.randomID()} 
                            columns={columns}  
                            dataSource={filteredSearchList}  
                            size="small" 
                            pagination={{
                                current: page,
                                pageSize,
                                onChange: (page) => setPage(page),
                              }}
                            />
                        </div>
                    </div>

                </div>
            </div>

        </div>


    )
}

export default ClubReceiptList